import { useEffect, useState } from "react";
import { Popup } from "@/components/common/Popup";
import { UserItem } from "@/components/user/UserItem";
import { SearchForm } from "@/components/common/SearchForm";
import { Toggle } from "@/components/ui/toggle";
import { UserInfo } from "@/components/user/UserInfo";
import { Trash2, Plus, ArrowDownNarrowWide, ArrowUpWideNarrow } from "lucide-react";

import { sortData } from "@/helper/sort";
import { SortCategory } from "@/helper/sort";
import { UserInfoSchema } from "@/components/user/UserSchema";
import { useApiFetch } from "@/helper/apiFetch";
import { useTranslate } from "@/helper/translate";






// Component
export function UserPage() {
  const colHeaders = [{ name: "User Name", sort: "userName" }, { name: "Role", sort: "isAdmin" }, { name: "Company", sort: "company" }, { name: "Active", sort: "isActive" },{ name: "Delete", sort: "" } ];

  const apiFetch = useApiFetch();
  const { translate } = useTranslate();

  const [users, setUsers] = useState<UserInfoSchema[]>([]);
  const [onlyActive, setActive] = useState(true);
  const [refreshCount, setRefreshCount] = useState(0);
  const [sortCategory, setSortCategory] = useState<SortCategory>();
  const [searchText, setSearchText] = useState<string>("");
  const [editUserId, setEditUser] = useState<string | null>(null);
  const [deleteUserId, setDeleteUserId] = useState<string | null>(null);

  // Utility: Filter search input
  function applySearchFilter(data: UserInfoSchema[], query: string): UserInfoSchema[] {
    const term = query.trim().toLowerCase();
    return data.filter(item => 
      (item.isActive == onlyActive || onlyActive == false) && (
      item.company?.toLowerCase().includes(term) ||
      item.userName.toLowerCase().includes(term))
    );
  }

  const handleSortCategoryChange = (newCategory: string | number) => {
    const newC: SortCategory = {
      name: newCategory,
      direction: sortCategory?.name === newCategory ? !sortCategory?.direction : true
    }

    setSortCategory(newC);
    setUsers(sortData(users, newC));
  };



//don't allow delete, we have userid refrenced, make inactive
  const deleteUser = ( userId: string) => {
    setDeleteUserId(userId);
  };

  const confirmDeleteUser = () => {
    if (!deleteUserId) return;

    const userId = deleteUserId;
    setDeleteUserId(null);

      apiFetch(`/App/DeleteUser?id=${userId}`, {
        method: "GET"
      }).then(res => {
        if (res.ok) {
          //remove from array
          setUsers(prev => prev.filter(s => s.userId !== userId));

        }
        else {
          res.text().then(text => {
            setUsers((prev) =>
              prev.map((s) =>
                s.userId === userId ? { ...s, error: text } : s
              )
            );
          })
        }
      }).catch(err => {
        console.error(err);
      })
  };

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    console.log('submit');
    e.preventDefault();
    const form = e.currentTarget;
    const input = form.querySelector("input");
    console.log(input?.value);
    setSearchText(input?.value.toLowerCase() || "");
  };

  const filteredData = applySearchFilter(users, searchText);
  const userItems = filteredData.map((item, index) => (

    <UserItem
      key={index}
      item={item}
      onClick={() => setEditUser(item.userId)}
      onDelete={deleteUser}
    />

  ));




  useEffect(() => {

    apiFetch(`/App/GetUsers`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch users");
        return res.json();
      })
      .then((data) => {
        setUsers(data);

      })
      .catch((err) => {
        console.error(err);
      });


  }, [refreshCount]);

  return (
    <div className="h-[calc(100vh-60px)] flex flex-col">
      <div className="content-header flex justify-between pt-[0.6rem] pb-[0.6rem] px-8 bg-gray-100 dark:bg-zinc-900">
        <div className="flex items-center gap-4">
          <h1 className="font-bold text-2xl">{translate("ui.users")}</h1>
          <Plus className="w-7 h-7 cursor-pointer bg-sky-600 hover:bg-sky-700 dark:bg-orange-400 dark:hover:bg-orange-500 rounded-full text-white dark:text-black" onClick={() => setEditUser("")} />
           {/* don't delete, we have userid refrenced, make inactive<Trash2 className="w-7 h-7 cursor-pointer bg-rose-600 hover:bg-rose-700 rounded-full text-white p-[3px]" onClick={deleteUsers} /> */}
        </div>
        <SearchForm 
          title={translate('ui.userSearch')}
          onSubmit={handleSearchSubmit} 
        />
        <div className="flex items-center gap-1">
          <Toggle
            title={translate('ui.usersActiveOnly')}
            checked={onlyActive}
            onChange={(e) => setActive(e.target.checked)}
          />
        </div>
      </div>

      <div className="flex-1 overflow-auto px-10">

        <div className="overflow-x-auto my-10 border rounded-xl shadow-2xl border-gray-100 dark:border-zinc-600">
          <table className="table-auto w-full border-collapse">
            <thead className="border-b border-gray-300 text-sm text-gray-600 dark:text-gray-50 dark:border-zinc-900">
              <tr>
                {colHeaders.map((header, index) => (
                  <th
                    key={index}
                    className="px-4 py-2 text-left cursor-pointer bg-gray-200 dark:bg-zinc-900"
                    onClick={() => handleSortCategoryChange(header.name)}
                  >
                    <div className=" flex items-center">
                     {translate("ui." + header.name.toLowerCase())}
                      {sortCategory?.name === header.sort ? (
                        sortCategory.direction ? (
                          <ArrowDownNarrowWide className="w-3 h-3" />
                        ) : (
                          <ArrowUpWideNarrow className="w-3 h-3" />
                        )
                      ) : <div className="w-3" />}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{userItems}</tbody>
          </table>
        </div>

      </div>



      <Popup
        isOpen={editUserId !== null}
        onClose={() => setEditUser(null)}
        title={translate("ui.userInfo")}
         className="w-[800px]"
      >
        <UserInfo onClose={(refresh:boolean) => {setEditUser(null); if(refresh) setRefreshCount(refreshCount+1);}} userId={editUserId??"" } />
      </Popup>

      <Popup
        isOpen={deleteUserId !== null}
        onClose={() => setDeleteUserId(null)}
        title={translate("ui.delete")}
        className="w-[400px]"
      >
        <div className="flex flex-col gap-6">
          <p>{translate("ui.confirmdeleteuser")}</p>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              className="rounded px-4 py-2 hover:bg-gray-200 dark:hover:bg-zinc-600"
              onClick={() => setDeleteUserId(null)}
            >
                {translate("common.cancel")}
            </button>
            <button
              type="button"
              className="rounded bg-rose-600 px-4 py-2 text-white hover:bg-rose-700"
              onClick={confirmDeleteUser}
            >
              {translate("common.delete")}
            </button>
          </div>
        </div>
      </Popup>
    </div>
  );
}
